import _ from 'lodash/fp'
import colors from '@fe/ui/colors'

const diffColorMap = {
  2: colors.primaryDarkRed,
  1: colors.lightOrange,
  0: colors.pieLightBlue,
  '-1': colors.pieNormalBlue,
  '-2': colors.primaryDarkBlue,
  '-3': colors.primaryDarkGreen
}

export const getDiffColor = (diff) => {
  if (diff > 2) {
    return colors.bordeaux
  }
  if (diff < -3) {
    return colors.lightGreen
  }
  return _.get(diff, diffColorMap)
}
